import { isValidLatitudeDegree, isValidLongitudeDegree } from "./validation.ts";

export const GEO_LOCATION_DEGREE = {
  NORTH: "° N",
  SOUTH: "° S",
  EAST: "° E",
  WEST: "° W",
} as const;

export const formatLatitudeDegree = (
  value?: number | null,
  precision?: number
) => {
  if (typeof value !== "number") {
    return "-";
  }

  const val =
    precision !== undefined
      ? Math.abs(value).toFixed(precision)
      : Math.abs(value);

  return isValidLatitudeDegree(value)
    ? `${val}${value > 0 ? GEO_LOCATION_DEGREE.NORTH : GEO_LOCATION_DEGREE.SOUTH}`
    : "unknown";
};

export const formatLongitudeDegree = (
  value?: number | null,
  precision?: number
): string => {
  if (typeof value !== "number") {
    return "-";
  }

  const val =
    precision !== undefined
      ? Math.abs(value).toFixed(precision)
      : Math.abs(value);

  return isValidLongitudeDegree(value)
    ? `${val}${value > 0 ? GEO_LOCATION_DEGREE.EAST : GEO_LOCATION_DEGREE.WEST}`
    : "unknown";
};

export const formatCoordinateDegrees = (
  coordinate: [number | null, number | null],
  precision?: number
) => {
  if (typeof coordinate[0] !== "number" || typeof coordinate[1] !== "number")
    return "-";

  return `${formatLatitudeDegree(coordinate[0], precision)}, ${formatLongitudeDegree(coordinate[1], precision)}`;
};
